export default __webpack_public_path__ + "static/media/transport_card_icon.1752c56f.svg";